module.exports = __webpack_public_path__ + "img/S350_S30_WS_001_2048x2048.9ac99868.png";